PJQ.views.submittals.WorkflowView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'submittal-workflow'),
        onChange: null,
        canEdit: true,
        canChangeBallInCourt: false,
        canRespond: true,
        onRespond: null,
        onSetBallInCourt: null
    },
    events: {
        'click .btn-edit-workflow': 'editWorkflow',
        'change .cb-required': 'approverRequiredChanged',
        'change .cb-reject-to-manager': 'returnOnRejectChanged',
        'keyup .input-days-to-respond': 'daysToRespondChanged',
        'click .btn-add-approver': 'addApprover',
        'click .btn-delete-approver': 'deleteApprover',
        'click .btn-add-step': 'addStep',
        'click .btn-apply-template': 'applyTemplateClicked',
        'click .btn-delete-step': 'deleteStepClicked',
        'click .btn-respond': 'respondToSubmittal',
        'click .btn-update-response': 'respondToSubmittal',
        'click .btn-set-bic': 'setBallInCourt',
        'click .dl-approver-attachment': 'downloadApproverAttachment'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.options.userSettings = await PJQ.app.session.fetchSubmittalUserSettings();
        if (this.options.project != null) {
            this.options.settings = await this.options.project.fetchSubmittalSettings();
            this.options.statuses = await this.options.project.fetchSubmittalStatuses();
        } else {
            this.options.settings = await PJQ.app.session.fetchSubmittalSettings();
            this.options.statuses = await PJQ.app.session.fetchSubmittalStatuses();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: async function () {
        this.options.canAdd = this.options.project ? this.options.project.hasPermission('submittals.canAdd') : PJQ.app.session.hasPermission('settings.canManageSubmittals');
        this.options.isAdmin = this.options.project ? this.options.project.hasPermission('submittals.isAdmin') : PJQ.app.session.hasPermission('settings.canManageSubmittals');

        if (this.isFetched && this.options.isEdit && this.workflowTemplates == null) {
            this.isFetched = false;
            this.workflowTemplates = await this.options.project.fetchSubmittalWorkflowTemplates();
            this.isFetched = true;
            this.render();
        }
    },
    renderData: function () {
        return {
            canEdit: this.options.canEdit,
            isEdit: this.options.isEdit === true,
            project: this.options.project,
            submittal: this.options.submittal,
            workflow: this.model,
            workflowTemplates: this.workflowTemplates,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderStepsTable();
    },
    setEdit: function (edit) {
        this.options.isEdit = edit;
        this.render();
    },
    editWorkflow: function () {
        this.setEdit(true);
    },
    approverRequiredChanged: function (e) {
        let $target = $(e.currentTarget),
            $badge = $target.closest('.badge-approver'),
            cid = $badge.data('cid'),
            stepCid = $badge.data('stepCid');

        let step = this.model.steps.get(stepCid);
        if (step == null) {
            return;
        }

        let approver = step.approvers.get(cid);
        if (approver == null) {
            return;
        }

        approver.set('isRequired', $target.prop('checked'));
        this.onChange(step);
    },
    returnOnRejectChanged: function (e) {
        let $target = $(e.currentTarget),
            $tr = $target.closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            step = row.data();
        if (step == null) {
            return;
        }

        step.set('returnOnReject', $target.prop('checked'));
        this.onChange(step);
    },
    daysToRespondChanged: function (e) {
        let $target = $(e.currentTarget),
            $tr = $target.closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            step = row.data();
        if (step == null) {
            return;
        }

        step.set('daysToRespond', parseInt($target.val()));
        this.onChange(step);
    },
    respondToSubmittal: function (e) {
        let $tr = $(e.currentTarget).closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            approver = row.data();
        new PJQ.views.submittals.WorkflowResponseModal({
            project: this.options.project,
            submittal: this.options.submittal,
            approver: approver,
            onSave: () => {
                if (typeof this.options.onRespond === 'function') {
                    this.options.onRespond(approver);
                }
            }
        });
    },
    setBallInCourt: function (e) {
        let $btn = $(e.currentTarget),
            stepCid = $btn.data('stepCid'),
            step = this.model.steps.get(stepCid);
        if (step == null) {
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Set Ball In Court?",
            body: "Are you sure you want to set this workflow step to the ball in court? This will reset all responses on the selected step.",
            onYes: () => {
                this.options.submittal.setBallInCourt(step.id, (success) => {
                    if (success) {
                        this.renderStepsTable();

                        if (typeof this.options.onSetBallInCourt === 'function') {
                            this.options.onSetBallInCourt(step);
                        }

                        PJQ.notifications.notify.successNotify({
                            message: 'Ball in court changed successfully'
                        });
                    }
                });
            }
        });
    },
    downloadApproverAttachment: function (e) {
        let cid = $(e.currentTarget).data('cid'),
            attachment = this.options.submittal.attachments.get(cid);
        if (attachment == null) {
            return;
        }

        attachment.download();
    },
    addApprover: function (e) {
        let $tr = $(e.currentTarget).closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            step = row.data(),
            approvers = _.map(_.filter(step.approvers.models, (approver) => {
                return !approver.get('delete');
            }), (approver) => {
                return {
                    id: approver.get('person').id
                };
            });
        this.selector = new PJQ.views.contacts.SelectContactsModal({
            contacts: this.options.contacts,
            hideContacts: approvers,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: false,
            // saveButtonText: this.options.saveButtonText,
            onSave: (newContacts) => {
                _.each(newContacts, (contact) => {
                    step.approvers.add(new PJQ.models.submittals.WorkflowApprover({
                        personId: contact.id,
                        isRequired: true,
                        person: contact.toJSON()
                    }));
                });
                this.renderStepsTable();
                this.onChange(step);
            }
        });
    },
    deleteApprover: function (e) {
        let $badge = $(e.currentTarget).closest('.badge-approver'),
            cid = $badge.data('cid'),
            stepCid = $badge.data('stepCid');

        let step = this.model.steps.get(stepCid);
        if (step == null) {
            return;
        }

        let approver = step.approvers.get(cid);
        if (approver == null) {
            return;
        }

        if (approver.id > 0) {
            approver.set('delete', true);
        } else {
            step.approvers.remove(approver);
        }

        this.renderStepsTable();
        this.onChange(step);
    },
    applyTemplateClicked: function (e) {
        let $btn = $(e.currentTarget),
            templateId = $btn.data('id'),
            template = this.workflowTemplates.get(templateId);

        if (_.find(this.model.steps.models, (step) => {
            return !step.get('delete')
        })) {
            new PJQ.views.modals.YesNo({
                header: "Apply Workflow Template?",
                body: "Are you sure you want to apply this workflow template? All current steps will be removed.",
                onYes: () => {
                    this.applyTemplate(template);
                }
            });
        } else {
            this.applyTemplate(template);
        }
    },
    applyTemplate: function (template) {
        let fnApplyTemplate = () => {
            let cWorkflow = template.workflow.clone();
            _.each(this.model.steps.models, (step) => {
                if (step.id > 0) {
                    step.set('delete', true);
                } else {
                    step.destroy();
                }
            });
            this.model.steps.add(cWorkflow.steps.models);
            this.renderStepsTable();

            this.onChange();
        };
        if (template.isFetched) {
            fnApplyTemplate();
        } else {
            template.fetch({
                success: () => {
                    fnApplyTemplate();
                },
                error: () => {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Failed to fetch template'
                    });
                }
            })
        }
    },
    addStep: function () {
        let step = new PJQ.models.submittals.WorkflowStep({
            number: _.filter(this.model.steps.models, (step) => {
                return !step.get('delete')
            }).length + 1,
            approvers: []
        });
        this.model.steps.add(step);
        this.renderStepsTable();
        this.onChange(step);
    },
    deleteStepClicked: function (e) {
        let $tr = $(e.currentTarget).closest('tr'),
            row = this.stepsDatatable.getRow($tr),
            step = row.data();
        this.deleteStep(step);
    },
    deleteStep: function (step) {
        if (step == null) {
            return;
        }

        if (step.id > 0) {
            step.set('delete', true);
        } else {
            this.model.steps.remove(step);
        }

        _.each(_.sortBy(_.filter(this.model.steps.models, (step) => {
            return !step.get('delete')
        }), (step) => {
            return step.id;
        }), (step, index) => {
            step.set('number', index + 1);
        });

        this.renderStepsTable();
        this.onChange(step);
    },
    onChange: function (step) {
        this.model.isDirty = true;
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(step);
        }
    },
    renderStepsTable: function () {
        let columns,
            data,
            approveLabel = this.options.settings.getApproveStatusName('ers');
        if (this.options.isEdit) {
            data = _.filter(this.model.steps.models, (step) => {
                return !step.get('delete');
            });
            columns = [
                {
                    "data": "attributes.number",
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false
                },
                {
                    "title": _.size(approveLabel) > 0 ? approveLabel : "Approvers",
                    "data": "approvers",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        let result = '',
                            approvers = row.approvers ? _.filter(row.approvers.models, (approver) => {
                                return !approver.get('delete')
                            }) : [];
                        if (_.size(approvers) === 0) {
                            result = 'Nobody';
                        } else {
                            let fnMakeCheckmark = (isRequired) => {
                                return '<div class="pretty p-default p-smooth ml-1"><input type="checkbox" class="cb-required" ' + (isRequired ? 'checked' : '') + ' /><div class="state p-primary"><label class="fs-15 division-expand noselect">&nbsp;</label></div></div>';
                            };
                            _.each(approvers, (approver) => {
                                result += '<div data-step-cid="' + row.cid + '" data-cid="' + approver.cid + '" class="badge-approver badge badge-light text-dark p-1 m-1 fs-14">' + fnMakeCheckmark(approver.get('isRequired')) + approver.get('person').contactName + '<button type="button" class="btn btn-sm btn-transparent-dark btn-delete-approver text-dark ml-1 fs-12"><span class="fal fa-times text-dark"></span></button></div>'
                            });
                        }

                        return '<div>' + result + '<button type="button" class="btn btn-sm btn-transparent-dark btn-add-approver text-primary ml-1 mr-1 fs-15"><span class="fal fa-plus"></span></button></div>';
                    }, this)
                },
                {
                    "data": "attributes.returnOnReject",
                    "title": 'Reject to Manager',
                    "width": "100px",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return '<div class="text-align-center"><div class="pretty p-default p-smooth"><input type="checkbox" class="cb-reject-to-manager" ' + (data ? 'checked' : '') + ' /><div class="state p-primary"><label class="fs-15">&nbsp;</label></div></div></div>';
                    }, this)
                },
                {
                    "data": "attributes.daysToRespond",
                    "title": 'Days to Respond',
                    "width": "100px",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return '<input type="number" class="form-control input-days-to-respond" value="' + (data ?? 0) + '">';
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "40px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        html += '<button type="button" class="btn btn-danger btn-delete-step ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button>'
                        return html + '</div>';
                    }, this)
                }];
        } else {
            data = [];
            _.each(this.model.steps.models, (step) => {
                let approvers = step.approvers.models;
                _.each(approvers, (approver) => {
                    approver.step = step;
                });
                data.push(...approvers);
            });
            columns = [
                {
                    "data": "step.attributes.number",
                    "columnData": "step.attributes.number",
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "visible": false,
                    group: (row) => {
                        return row.step.cid;
                    }
                },
                {
                    "data": "attributes.id",
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    render: (data, type, row) => {
                        // show icon if this is the current user
                        return '';
                    }
                },
                {
                    "data": "attributes.person",
                    "title": "Name",
                    "width": "200px",
                    "orderable": false,
                    "searchable": false,
                    "render": (data, type, row) => {
                        let personAnchor = PJQ.helpers.contacts.getContactAnchor({contact: row.get('person')}),
                            req = '';
                        if (row.get('isRequired'))
                            req = '<i class="fal fa-asterisk mr-2"></i>';
                        return '<div class="d-flex align-items-center"><div style="width:30px">' + req + '</div><div><div class="font-weight-bold">' + row.get('person').companyName + '</div><div>' + personAnchor + '</div></div></div>';
                    }
                },
                {
                    "data": "attributes.ballInCourtOn",
                    "title": 'Sent',
                    "render": (data, type, row) => {
                        if (data == null) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "data": "attributes.dueOn",
                    "title": 'Due',
                    "width": '90px',
                    "render": (data, type, row) => {
                        if (data == null) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "data": "attributes.responseOn",
                    "title": "Responded",
                    "width": "100px",
                    "render": (data, type, row) => {
                        if (data == null) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }
                },
                {
                    "data": "attributes.statusId",
                    "title": "Response",
                    "width": "120px",
                    "render": (data, type, row) => {
                        if (data > 0) {
                            let status = this.options.statuses.get(data);
                            if (status == null) {
                                return '';
                            }

                            let sColor = PJQ.constants.submittals.statusTypeColors[status.get('color')];
                            return '<span style="color:' + sColor + '">' + status.get('name') + '</span>';
                        } else if (!this.options.canRespond || !row.step.get('isActive') || !row.get('isMe')) {
                            return '';
                        }
                        return '<div class="text-align-center"><button type="button" class="btn btn-light btn-respond">Respond</button></div>';
                    }
                },
                {
                    "data": "attributes.responseText",
                    "title": "Comments",
                    "orderable": false,
                    "render": (data, type, row) => {
                        return row.get('responseText') ?? '';
                    }
                },
                {
                    "data": "attachments",
                    "title": "Attachments",
                    "orderable": false,
                    "render": (data, type, row) => {
                        if (this.options.submittal == null || this.options.submittal.attachments == null) {
                            return '';
                        }

                        let approverAttachments = [];
                        _.each(this.options.submittal.attachments.models, (attachment) => {
                            if (attachment.get('approverId') === row.id) {
                                approverAttachments.push({
                                    cid: attachment.cid,
                                    name: attachment.get('name'),
                                    newest: _.size(attachment.versions?.models) === 0
                                });
                            }

                            if (attachment.versions != null && attachment.versions.models.length > 0) {
                                let newestVer = _.max(attachment.versions.models, (ver) => {
                                    return ver.get('version');
                                }).get('version');
                                _.each(attachment.versions.models, (ver) => {
                                    if (ver.get('approverId') !== row.id) {
                                        return;
                                    }

                                    approverAttachments.push({
                                        cid: ver.cid,
                                        name: ver.get('name'),
                                        newest: newestVer === ver.get('version')
                                    });
                                })
                            }
                        });
                        if (approverAttachments.length === 0) {
                            return '';
                        }

                        let result = '';
                        _.each(approverAttachments, (attachment) => {
                            result += '<a href="javascript:void(0)" class="btn-dl-approver-attachment ' + (attachment.newest ? '' : 'text-dec-line-through') + '" data-cid="' + attachment.cid + '">' + attachment.name + '</a><br>';
                        });
                        return '<div class="fs-14">' + result + '</div>';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "40px",
                    "render": (data, type, row) => {
                        if (!this.options.canRespond || !row.step.get('isActive') || (!this.options.isAdmin && (!row.get('isMe') || row.get('statusId') == null))) {
                            return '';
                        }

                        return `<div class="btn-group">
                                    <button type="button"
                                            class="btn fs-16 btn-transparent-dark text-dark dropdown-toggle" data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false">
                                        <i class="fas fa-ellipsis-vertical"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item btn-update-response"
                                           href="javascript:void(0)">Update Response</a>
                                    </div>
                                </div>`;
                    }
                }];
        }

        this.stepsDatatable = new PJQ.views.dataTables.DataTable({
            el: this.$('.dt-steps'),
            data: data,
            isHideSearch: true,
            groupBy: this.options.isEdit ? null : 'step.attributes.number',
            language: {
                emptyTable: 'No Steps have been created yet',
                zeroRecords: 'No Steps have been created yet'
            },
            isStriped: false,
            paging: false,
            order: [[0, "asc"]],
            columns: columns,
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteStep(row.data());
                        },
                        isShown: () => {
                            return this.options.isEdit;
                        },
                    }
                ]
            },
            disableGroupToggle: true,
            getGroupHeader: (group) => {
                let step = this.model.steps.get(group),
                    bicBtn = '';
                if (!step.get('isActive') && this.options.canChangeBallInCourt) {
                    bicBtn = '<button data-step-cid="' + step.cid + '" class="btn fs-14 btn-sm btn-outline-dark btn-set-bic ml-auto">Set Ball In Court</button>';
                }

                let activeBadge = '';
                if (step.get('isActive') && this.options.canRespond) {
                    activeBadge = '<span class="badge badge-success fs-12 ml-2">Active</span>';
                }

                return '<div class="d-flex align-items-center wd-100 p-2" style="height:50px"><div class="fs-16 font-weight-light"><strong>#' + step.get('number') + '</strong></div>' + activeBadge + bicBtn + '</div>';
            },
            onRowDoubleClick: () => {

            },
        });
    }
});

PJQ.views.submittals.WorkflowResponseModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-workflow-response'),
        maxWidth: 650,
    },
    events: {
        'keyup .input-comment': 'commentChanged',
        'click .btn-back': 'previousStep',
        'click .btn-next': 'nextStep',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.step = 1;

        this.options.statuses = await this.options.project.fetchSubmittalStatuses();

        if (this.model == null) {
            this.model = new PJQ.models.submittals.WorkflowResponse({
                submittalId: this.options.submittal.id
            });
        }
        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            approver: this.options.approver,
            statuses: this.options.statuses,
            submittal: this.options.submittal,
            step: this.step
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.StepIndicator(this.$('.steps-outer'), {
            steps: [{
                name: '',
                // name: 'Upload Attachments'
            }, {
                name: '',
                // name: 'Respond'
            }, {
                name: '',
                // name: 'Review & Submit'
            }],
            activeStep: this.step - 1
        });

        switch (this.step) {
            case 1:
                this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                    el: this.$('.step-uploader'),
                    collection: this.model.attachments,
                    includeProjectAttachments: true,
                    versionByName: true,
                    getParentAttachment: (fileModel) => {
                        return _.find(this.options.submittal.attachments.models, (file) => {
                            return file.get('name') === fileModel.get('name') && !file.get('delete')
                                && (file.get('parentAttachmentId') == null || file.get('parentAttachmentId') === file.id);
                        });
                    },
                    onSuccess: _.bind(function () {

                    }, this),
                    onDelete: _.bind(function (attachment, callback) {

                    }, this)
                });
                break;
            case 2:
                this.statusPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.select-status'),
                    noneSelectedText: 'Select Status',
                    isIntChoices: true,
                    defaultValue: this.model.get('statusId'),
                    choices: _.map(_.filter(this.options.statuses.models, (status) => {
                        return status.get('type') === PJQ.constants.submittals.statusTypes.APPROVED || status.get('type') === PJQ.constants.submittals.statusTypes.REJECTED;
                    }), (status) => {
                        return {
                            id: status.id,
                            name: status.get('name')
                        };
                    }),
                    onChange: _.bind(function (value) {
                        this.model.set('statusId', value);
                    }, this)
                });
                break;
            case 3:
                break;
        }
    },
    commentChanged: function (e) {
        this.model.set({
            responseText: this.$('.input-comment').val()
        });
    },
    previousStep: function () {
        this.step--;
        this.render();
    },
    nextStep: function () {
        switch (this.step) {
            case 1:
                break;
            case 2:
                if (this.model.get('statusId') == null) {
                    this.statusPicker.showError();
                    return;
                }
                break;
            case 3:
                break;
        }

        this.step++;
        this.render();
    },
    save: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.options.submittal.respond(this.model, this.options.approver?.get('personId'), (success) => {
            if (!success) {
                loader.remove();
                return;
            }

            this.options.onSave(this.model);
            this.removeModal();

            PJQ.notifications.notify.successNotify({
                message: 'Response submitted successfully'
            });
        });
    },
    cancel: function () {
        new PJQ.views.modals.YesNo({
            header: "Cancel Response?",
            body: "Are you sure you want to cancel this response? All changes will be lost.",
            onYes: () => {
                this.removeModal();
            }
        });
    }
});

PJQ.views.submittals.EditWorkflowTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-edit-workflow-template'),
        maxWidth: 650,
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-delete': 'deleteTemplate'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.model != null) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.model.isNew()) {
            this.$('.input-template-name').focus();
        }

        this.binder = new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        this.workflowView = new PJQ.views.submittals.WorkflowView({
            el: this.$('.workflow-outer'),
            model: this.model.workflow,
            project: this.options.project,
            isEdit: true,
            canEdit: true,
            onChange: () => {
                this.model.isDirty = true;
            }
        });
    },
    validate: function () {
        let $name = this.$('.input-template-name');
        PJQ.helpers.inputHelpers.setInputError($name, true);
        if (this.model.get('name') == null || this.model.get('name').trim() === '') {
            PJQ.helpers.inputHelpers.setInputError($name, false);
            return false;
        }

        return true;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        this.model.save(null, {
            success: () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();

                PJQ.notifications.notify.successNotify({
                    message: 'Template saved successfully'
                });
            },
            error: () => {
                PJQ.notifications.notify.errorNotify({
                    message: 'An error occurred while saving the template'
                });
            }
        });
    },
    cancel: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    deleteTemplate: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Submittal Workflow Template?",
            body: "Are you sure you want to delete this workflow template? This cannot be undone.",
            onDelete: () => {
                this.model.destroy({
                    success: () => {
                        if (typeof this.options.onSave === 'function') {
                            this.options.onDelete();
                        }
                        this.removeModal();
                    },
                    error: () => {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to delete workflow template'
                        });
                    }
                });
            }
        });
    }
});